import React from 'react';
import { CheckIcon, LockIcon, ZapIcon } from 'lucide-react';
import { CountdownClock } from './CountdownClock';
import { CtaButton } from './CtaButton';
import { product, included } from '../data/content';
export function OfferSection() {
  return <section id="offer" className="w-full scroll-mt-14 bg-sand py-16 sm:py-20" aria-labelledby="offer-heading" data-id="element-161" data-mp="8m3ydu9pbk0k">
      <div className="mx-auto max-w-3xl px-5" data-id="element-162" data-mp="idi2kfcll801">
        <div className="text-center" data-id="element-163" data-mp="icot36m984e7">
          <p className="font-sans text-xs font-bold uppercase tracking-[0.24em] text-alert" data-id="element-164" data-mp="metl60x20syq">
            Limited-time offer
          </p>
          <h2 id="offer-heading" className="mt-4 font-display text-3xl font-semibold leading-tight tracking-tight text-espresso sm:text-4xl" data-id="element-165" data-mp="rey2ft5sdrq0">
            Launch pricing expires in
          </h2>
          <div className="mt-7" data-id="element-166" data-mp="2t7454toqjes2">
            <CountdownClock tone="dark" data-id="element-167" data-mp="2y4clqpu8jar7" />
          </div>
          <p className="mt-5 font-sans text-sm text-muted" data-id="element-168" data-mp="2y4w5mc3g497v">
            Launch pricing ends today. After that, pricing returns to $97.
          </p>
        </div>

        <div className="mt-10" data-id="element-169" data-mp="xwjtebrbgvlh">
          <div className="flex items-baseline justify-between gap-4" data-id="element-170" data-mp="xv8rkhhflxx0">
            <p className="font-sans text-[11px] font-bold uppercase tracking-[0.14em] text-cocoa" data-id="element-171" data-mp="swxii8yynrfu">
              Limited availability — today only
            </p>
            <p className="font-sans text-sm font-bold text-alert" data-id="element-172" data-mp="1lme52pzwge45">68% claimed</p>
          </div>
          <div className="mt-2 h-2 w-full overflow-hidden rounded-full bg-espresso/10" role="img" aria-label="68 percent of launch spots claimed" data-id="element-173" data-mp="1lk0bklkvb9yp">
            <div className="h-full w-[68%] rounded-full bg-alert" data-id="element-174" data-mp="1cniyhcsy120b" />
          </div>
        </div>

        <div className="mt-10 overflow-hidden rounded-2xl border border-espresso/10 bg-cream shadow-card" data-id="element-175" data-mp="17oxx3a1ygcaa">
          <div className="border-b border-espresso/10 px-7 py-6 text-center sm:px-10" data-id="element-176" data-mp="3scu2k00nuzra">
            <p className="font-sans text-[11px] font-bold uppercase tracking-[0.16em] text-gold" data-id="element-177" data-mp="3sewzz5457v61">
              {product.name} — complete package
            </p>
            <p className="mt-2 font-display text-2xl font-semibold text-espresso" data-id="element-178" data-mp="2mdj00sjzjzy">
              6 Volumes + 5 Strategic Bonuses
            </p>
          </div>

          <div className="px-7 py-8 sm:px-10" data-id="element-179" data-mp="3oumvwxla5v8y">
            <p className="font-sans text-[11px] font-bold uppercase tracking-[0.16em] text-muted" data-id="element-180" data-mp="3otbpsr4d4beo">
              What&rsquo;s included
            </p>
            <ul className="mt-4 grid gap-3 sm:grid-cols-2" data-id="element-181" data-mp="3ftyhi1rz5svj">
              {included.map(item => <li key={item} className="flex items-start gap-3" data-id="element-182" data-mp="315lptgzx6w6u">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-183" data-mp="31394quyv85pk" />
                  <span className="font-sans text-base text-cocoa" data-id="element-184" data-mp="2s5oyf7m5bj83">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="border-t border-espresso/10 bg-espresso px-7 py-8 text-cream sm:px-10" data-id="element-185" data-mp="2x5jqhehnqeuq">
            <p className="text-center font-sans text-[11px] font-bold uppercase tracking-[0.16em] text-cream/60" data-id="element-186" data-mp="2djrx8ocvlhvo">
              Total real value: {product.compareAt}
            </p>
            <div className="mt-4 flex items-end justify-center gap-4" data-id="element-187" data-mp="2mjy9k6wu8bt9">
              <p className="font-display text-6xl font-semibold leading-none" data-id="element-188" data-mp="2ifywxzeohx56">
                {product.price}
              </p>
              <p className="font-display text-2xl font-semibold text-cream/50 line-through" data-id="element-189" data-mp="2weyfcpbllfsw">
                {product.compareAt}
              </p>
            </div>
            <p className="mt-4 text-center font-sans text-sm font-bold uppercase tracking-[0.12em] text-goldlight" data-id="element-190" data-mp="365kqo7ca7k5s">
              {product.savings}
            </p>
            <p className="mt-1 text-center font-sans text-[11px] uppercase tracking-[0.16em] text-cream/60" data-id="element-191" data-mp="3f7alln5dh18b">
              One-time payment · Lifetime access
            </p>

            <div className="mt-8" data-id="element-192" data-mp="3a64prggf0xuk">
              <CtaButton label="Yes, I want the Bible" size="large" tone="gold" data-id="element-193" data-mp="18jjydkhuklup" />
            </div>
            <p className="mt-4 text-center font-sans text-sm text-cream/70" data-id="element-194" data-mp="1dhlfw0zmkd42">
              Covered by our 7-day money-back guarantee.
            </p>
            <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-2" data-id="element-195" data-mp="1i9mzy931b84n">
              <li className="flex items-center gap-2 font-sans text-xs text-cream/60" data-id="element-196" data-mp="1m9x7hq6h66lm">
                <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-197" data-mp="plhcvfoid71n" /> Secure payment
              </li>
              <li className="flex items-center gap-2 font-sans text-xs text-cream/60" data-id="element-198" data-mp="ujsonvyd5rmi">
                <ZapIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-199" data-mp="yk2tv6ec0e0b" /> Instant access
              </li>
              <li className="font-sans text-xs text-cream/60" data-id="element-200" data-mp="13kqhdi3cqcps">
                Card · Google Pay · Apple Pay
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}